<app-articolo-view [idArticolo]="9" ></app-articolo-view>